import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";

export const Container = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  // gap: "40px",
  // margin: "0 0 20px",

  ".MuiButton-root": {
    "& svg": {
      fontSize: `${theme.typography.body2.fontSize}px`,
    },
  },

  ".close": {
    marginLeft: "auto",
    marginRight: 0,
    visibility: "visible",
    opacity: 1,
  },
}));

export const EmployeeContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  gap: "3px",
  "& > .MuiTypography-root": {
    padding: "10px",
    backgroundColor: theme.palette.background.paper,
    "&:first-of-type": {
      borderRadius: "0px",
    },
    "&:last-of-type": {
      borderRadius: "0px 5px 0px 0px",
    },
  },
}));
